import { ApiSubspace, Subspace } from './subspace.types'

export function parseApiSubspace({ ...subspaceData }: ApiSubspace): Subspace {
  return {
    ...subspaceData,
  }
}
